import { CanDeactivateFn } from '@angular/router';
import { CreditorClaimFormComponent } from './creditor-claim-form.component';

export const creditorClaimFormGuard: CanDeactivateFn<CreditorClaimFormComponent> = (component) => {
  return component.canDeactivate();
};
